import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Plus } from "lucide-react";

const QUESTIONS = [
  { qk: "markets.faq.q1", ak: "markets.faq.a1" },
  { qk: "markets.faq.q2", ak: "markets.faq.a2" },
  { qk: "markets.faq.q3", ak: "markets.faq.a3" },
  { qk: "markets.faq.q4", ak: "markets.faq.a4" },
  { qk: "markets.faq.q5", ak: "markets.faq.a5" },
  { qk: "markets.faq.q6", ak: "markets.faq.a6" },
];

function FAQ() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(0);

  const toggle = (i) => setOpen(open === i ? -1 : i);

  return (
    <section className="mt">
      <div className="glcontainer mb-[40px] xl:mb-[60px]">
        <h2 className="font-['Montserrat'] font-black text-[32px] xl:text-[64px] text-[#0a0a0a] tracking-[-0.92px] uppercase leading-none">
          {t("markets.faq.title")}
        </h2>
      </div>

      <div className="w-full flex flex-col">
        {QUESTIONS.map((q, i) => {
          const isOpen = open === i;
          return (
            <div key={i} className="border-b border-[rgba(0,0,0,0.1)] w-full">
              <button
                onClick={() => toggle(i)}
                className="w-full text-left glcontainer flex items-start justify-between py-[20px] xl:py-[30px] gap-[20px]"
              >
                <div className="flex flex-col gap-[20px] flex-1">
                  <span className="font-['Montserrat'] font-extrabold text-[16px] xl:text-[20px] text-[#020202] leading-normal">
                    {t(q.qk)}
                  </span>
                  {isOpen && (
                    <p className="font-['Inter'] font-normal text-[14px] xl:text-[16px] text-[rgba(0,0,0,0.7)] leading-[1.5]">
                      {t(q.ak)}
                    </p>
                  )}
                </div>
                <div className={`shrink-0 mt-[2px] transition-transform duration-200 ${isOpen ? "rotate-45" : ""}`}>
                  <Plus size={14} className="text-[#020202]" strokeWidth={2} />
                </div>
              </button>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default FAQ;
